// Server-driven status for the per-user image restoration section.
// Mirrors the values returned by GET /api/internal/items/image_restore.
export const IMAGE_RESTORE_STATUS = {
  IDLE: 'idle',
  PENDING: 'pending',
  FINISHED: 'finished',
  CLOSED: 'closed',
}
